export default __webpack_public_path__ + "static/card-issued-4732b38573413b6026e2651c7146d8be.svg";